module.exports = __webpack_public_path__ + "static/media/16 Backpack.ed43be03.jpg";